import { api } from '../utils/endpoint.js'
import * as dayjs from 'dayjs'

export const KEK_TITLES = 'garagesAtom'
export const NEW_GARAGE = 'newGarage'
export const GARAGE_SELECTOR = 'selector'

const fetchGarages = async () => {
  const fetchData = async () => {
    try {
      const response = await fetch(api.nonemcsApi.getGarages('?lang=TH'));
      if (!response.ok) {
        throw new Error('');
      }
      const data = await response.json();
      return data
    } catch (error) {
      console.error(error)
    }
  };
  const responseAll = await fetchData();
  
  const arrayGareages = responseAll.data.map((item) => {
    return { label: item.nameTh, value: item.code, address:`${item.addr} ${item.amphur} ${item.province}`  }
  })

  const result = {
    data: arrayGareages,
    expire: dayjs().add(10, 'm').valueOf()
  }

  localStorage.setItem(KEK_TITLES, JSON.stringify(result))
  return result
}

const getGarages = async () => {
  let garagesAtom = JSON.parse(localStorage.getItem(KEK_TITLES) || '{}')
  if (Object.keys(garagesAtom).length === 0) {
    garagesAtom = await fetchGarages()
  }

  if(dayjs().valueOf() > garagesAtom?.expire){
    garagesAtom = await fetchGarages()
  }

  let arrayGarages = {}
  garagesAtom?.data.map((item) => {
      arrayGarages = Object.assign(arrayGarages, { [item.value]: item.label })
  })

  const listGarages = formatGarages(garagesAtom?.data)
  return { arrayGarages, listGarages}
}

const formatGarages = (data) => {
  const listData = []
  for (const key in data) {
    if (Object.hasOwnProperty.call(data, key)) {
      listData.push({
        id: data[key].value,
        name: data[key].label,
        address: data[key].address
      })
    }
  }
  return listData
}

export { getGarages, fetchGarages }
